export default "__VITE_ASSET__DUp47zQG__"